import type { HTMLAttributes } from "react";
import { clsx } from "clsx";

// Keep absolutely positioned app content (including sr-only headings) inside
// its scroll owner so it cannot enlarge or scroll the outer document.
export function AppContentPanel({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={clsx("relative min-h-0 min-w-0 flex-1 overflow-auto", className)}
      {...props}
    />
  );
}
